import axios from "axios";
import { axiosInstanceApiNestingale } from "../axios";
const fetchRoomLabels = async (roomType: string, CustomerID: string) => {
    return await axios.post(`https://api.nestingale.com/v1/api/customer-onboarding/room-labels`, { CustomerID, roomType })
};
export default fetchRoomLabels